// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"eb7333f4","455":"fe442174","977":"7f3c32cb"}[chunkId] + ".chunk.js";
};